// Polls GET mux/videos/:id/status (server-side throttled) until Mux is done.
export function createMuxPoller({
  videoId,
  fetchStatus,
  onUpdate,
  onReady,
  intervalMs = 5000,
  maxMs = 30 * 60 * 1000,
  now = () => Date.now(),
  setTimer = (fn, ms) => setTimeout(fn, ms),
  clearTimer = id => clearTimeout(id),
}) {
  const startedAt = now();
  let timer = null;
  let stopped = false;

  function schedule() {
    if (stopped || now() - startedAt >= maxMs) return;
    timer = setTimer(tick, intervalMs);
  }

  async function tick() {
    timer = null;
    if (stopped) return;
    try {
      const fresh = await fetchStatus(videoId);
      if (stopped) return;
      onUpdate(fresh);
      if (fresh.mux_status === 'ready') {
        stopped = true;
        await onReady(fresh);
        return;
      }
      if (fresh.mux_status === 'errored') {
        stopped = true;
        return;
      }
    } catch (error) {
      // A transient API or bridge failure: try again on the next tick.
    }
    schedule();
  }

  schedule();
  return {
    stop() {
      stopped = true;
      if (timer) clearTimer(timer);
      timer = null;
    },
  };
}
